import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import FruitListingg from '../../Assets/Images/FruitListingsHeader.png';
import Alphonso from '../../Assets/Images/Alphonso.png';
import Sindhura from '../../Assets/Images/Sindhura.png';
import Strawberry from '../../Assets/Images/Strawberry.png';
import BlackGrapes from '../../Assets/Images/BlackGrapes.png';
import Oranges from '../../Assets/Images/Oranges.png';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Badge } from "react-bootstrap";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { Card, Container, Form } from "react-bootstrap";
import Calender from '../../Assets/Images/Homepage_Calendar.png';
import { PageType } from '../../Models/Enum';
import { SimpleResponse } from '../../Models/ResponseModel';
import { PageSummary_SearchRequest } from '../../Models/Model';
import pageService from '../../Services/pageService';
import FruitCard from '../../Components/FruitCard';
import PageRenderer from '../../Components/PageRenderer';
import { response } from 'express';



function generateAboveCardsXl(item, index) {

   if (index < 8) {
      return (
         (<div className='col mb-4' key={index} >
            <FruitCard item={item} />
         </div>)
      )
   }



}

function generateAboveCards(item, index) {

   if (index < 6) {
      return (
         (<div className='col mb-3 listCard' key={index}  >
            <FruitCard item={item} />
         </div>)
      )
   }



}

function generateBelowCardsXl(item, index) {
   if (index >= 8) {
      return (
         (<div className='col mb-4' key={index} >
            <div key={index} className='ps-2 pe-2  '>
               <FruitCard item={item} />
            </div>
         </div>)

      )
   }

}


function generateBelowCards(item, index) {
   if (index >= 6) {

      return (
         (<div className='col mb-3 listCard' key={index}  >
            <FruitCard item={item} />
         </div>)

      )
   }

}




function FruitListing(props) {
  
   const [AllCards, setAllCards] = useState([]);
   const [Cards, setCards] = useState([]);
   const [fruitName, setFruitName] = useState([]);


   useEffect(() => {

      getCardData();
      getFilterData();

   }, []);

   const getCardData = async () => {

      let req = new PageSummary_SearchRequest();
      req.PageTypeID = PageType.FruitDetail;

      try {
         let resp: SimpleResponse = await pageService.getInstance().PageSummary_Search(req);
         if (resp.HasError) {
            return;
         }


         // var cardIndexes = [];
         // for (let i = 0; i < 10; i++) {
         //    cardIndexes.push(resp.Result[0])
         // }
         // // cardIndexes.push(resp.Result , resp.Result, resp.Result, resp.Result,  resp.Result,  resp.Result, resp.Result,  resp.Result,  resp.Result)
         // resp.Result = cardIndexes;
        


         setAllCards(resp.Result);
         setCards(resp.Result);
      } catch (e) {

      }
   }

   const getFilterData = async () => {

      let req = new PageSummary_SearchRequest();
      req.PageTypeID = PageType.FruitCategory;

      try {
         let resp: SimpleResponse = await pageService.getInstance().PageSummary_Search(req);
         if (resp.HasError) {
            return;
         }
         setFruitName(resp.Result);
      } catch (e) {

      }
   }

   const onFilterChange = (ID) => {
      if (ID == 0) {
         setCards(AllCards);
         return;
      }
      setCards(AllCards.filter(e => e.ParentPageID == ID));
   }


   return (
      <div className='container-fluid'>

         <div className='row mb-5 fruitListingImg' style={{ backgroundImage: `url(${FruitListingg})` }}>
            <div className='col-12 text-center pt-5 pb-5 my-auto'  >
               <h2 className='pb-3'>Premium Indian fruits, <br />traceable back to farm</h2>

            </div>
         </div>

         <div className='row mb-2'>
            <div className='col-12'>
               <Container>
                  <div className='row mb-4'>
                     <div className='col-12 col-lg-4'>
                        <Form.Select aria-label="Default select example" className="rounded-4" onChange={(e) => onFilterChange(e.target.value)}>
                           <option value={0}>All</option>
                           {fruitName != undefined && fruitName.length > 0 && fruitName.map((item, index) => (
                              <option key={index} value={item.PageID}>{item.Name}</option>
                           ))}
                        </Form.Select>
                     </div>
                  </div>
               </Container>
            </div>
         </div>

         {/* <div className="row mb-5">
            <div className="col">
               <Container>
                  <Row xs={1} md={2} lg={3} xl={4}>
                     {Cards != undefined && Cards.length > 0 && Cards.map((item, index) => (
                        <Col key={index} className='ps-2 pe-2'>
                           <FruitCard item={item} />

                        </Col>
                     ))}
                  </Row>
               </Container>
            </div>
         </div> */}


         

         <div className='row mb-5 pb-0 pb-lg-5 d-xl-flex d-none'>
            <div className="col">
               <Container className='ps-1'>
                  <Row xs={1} md={2} lg={3} xl={4}  >
                     {
                        (Cards != null && Cards.map((item, index) => {
                           return generateAboveCardsXl(item, index);
                        }))
                     }
                  </Row>
               </Container>
            </div>
         </div>

         <div className='row mb-5 pb-0 pb-lg-5 d-xl-none'>
            <div className="col">
               <Container >
                  <Row xs={1} md={2} lg={3} xl={4} className="fruitCardList" >
                     {
                        (Cards != null && Cards.map((item, index) => {
                           return generateAboveCards(item, index);
                        }))
                     }
                  </Row>
               </Container>
            </div>
         </div>





         <div className='row mb-5 pb-0 pb-lg-5'>
            <div className='col'>
               <Container>
                  <div className='row mb-3'>
                     <div className='col'>
                        <h1 className='text-center'>Available throughout the year</h1>
                     </div>
                  </div>
                  <div className='row justify-content-center'>
                     <div className='col-auto'>
                        <img src={Calender} className='img-fluid' />
                     </div>
                  </div>

               </Container>
            </div>
         </div>

         <div className='row d-xl-flex d-none mb-5 pb-0 pb-lg-5'>
            <div className="col">
               <Container className='ps-1'>
                  <Row xs={1} md={2} lg={3} xl={4}>
                     {
                        (Cards != null && Cards.map((item, index) => {
                           return generateBelowCardsXl(item, index);
                        }))
                     }
                  </Row>
               </Container>
            </div>
         </div>

         <div className='row d-xl-none mb-5 pb-0 pb-lg-5' >
            <div className="col">
               <Container className='ps-0 ps-lg-2'>
                  <Row xs={1} md={2} lg={3} xl={4} className="fruitCardList">
                     {
                        (Cards != null && Cards.map((item, index) => {
                           return generateBelowCards(item, index);
                        }))
                     }
                  </Row>
               </Container>
            </div>
         </div>

         {/* <div className="row mb-5">
            <div className="col">
               <Container>
                  <div className="row mb-4 ">
                     <div className="col-12 col-lg">
                        <div className='row  position-relative CustomCardGrapes g-0'>
                           <div className='col-8 '>
                              <Card.Img variant="top" src={BlackGrapes} />
                           </div>
                           <div className='col-4 align-self-center'>
                              <Card.Body>
                                 <Card.Title>Grapes</Card.Title>
                                 <Card.Text>
                                    Flavour details Lorem ipsum dolor sit amet. Id ducimus molestias id doloremque eaque.
                                 </Card.Text>
                                 <Badge>Jan-Mar</Badge>
                              </Card.Body>
                              <div className=' SeasonalFruitArrow' style={{backgroundColor : "#dcc3f5"}}>
                                 <FontAwesomeIcon icon={faArrowRight} />
                              </div>
                           </div>
                        </div>


                     </div>
                     <div className="col-12 col-lg">
                        <div className="row ">
                           <div className='col-12 col-lg'>
                              <Card className='CustomCard' style={{backgroundColor:"#fde1e3"}}>
                                 <Card.Img variant="top" src={Sindhura} />
                                 <Card.Body >
                                    <Card.Title >Strawberry</Card.Title>
                                    <Card.Text >
                                       Flavour details Lorem ipsum
                                       dolor sit amet. Id ducimus
                                       molestias id doloremque eaque.
                                    </Card.Text>
                                    <Badge >Jan-Mar</Badge>
                                 </Card.Body>
                                 <div className='SeasonalFruitArrow' style={{backgroundColor : "#f4b9bf"}}>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                 </div>
                              </Card>
                           </div>
                           <div className='col-12 col-lg'>
                              <Card className='CustomCard' style={{backgroundColor: "#fbf3d4"}}>
                                 <Card.Img variant="top" src={Sindhura} />
                                 <Card.Body >
                                    <Card.Title >Strawberry</Card.Title>
                                    <Card.Text >
                                       Flavour details Lorem ipsum
                                       dolor sit amet. Id ducimus
                                       molestias id doloremque eaque.
                                    </Card.Text>
                                    <Badge >Jan-Mar</Badge>
                                 </Card.Body>
                                 <div className='SeasonalFruitArrow' style={{backgroundColor : "#f4e09b"}}>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                 </div>
                              </Card>
                           </div>
                        </div>

                     </div>
                  </div>

                  <div className="row ">
                     <div className="col  ">
                        <Card className='filterCustomCardOrange '>
                           <Card.Img variant="top" src={Oranges} />
                           <Card.Body className="ms-4">
                              <Card.Title >Orange</Card.Title>
                              <Card.Text >
                                 Flavour details Lorem ipsum
                                 dolor sit amet.<br /> Id ducimus
                                 molestias id doloremque eaque.
                              </Card.Text>
                              <Badge >Jan-Mar</Badge>
                           </Card.Body>
                           <div className='SeasonalFruitArrow' style={{backgroundColor : "#ffd2b3"}}>
                              <FontAwesomeIcon icon={faArrowRight} />
                           </div>
                        </Card>
                     </div>

                     <div className="col-12 col-lg">
                        <div className="row mb-4">
                           <div className='col-12 col-lg'>
                              <Card className='CustomCard' style={{backgroundColor:"#f3e6ff"}}>
                                 <Card.Img variant="top" src={Sindhura} />
                                 <Card.Body >
                                    <Card.Title >Strawberry</Card.Title>
                                    <Card.Text >
                                       Flavour details Lorem ipsum
                                       dolor sit amet. Id ducimus
                                       molestias id doloremque eaque.
                                    </Card.Text>
                                    <Badge >Jan-Mar</Badge>
                                 </Card.Body>
                                 <div className='SeasonalFruitArrow' style={{backgroundColor : "#dcc3f5"}}>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                 </div>
                              </Card>
                           </div>
                           <div className='col-12 col-lg'>
                              <Card className='CustomCard' style={{backgroundColor:"#fbddde"}}>
                                 <Card.Img variant="top" src={Sindhura} />
                                 <Card.Body >
                                    <Card.Title >Strawberry</Card.Title>
                                    <Card.Text >
                                       Flavour details Lorem ipsum
                                       dolor sit amet. Id ducimus
                                       molestias id doloremque eaque.
                                    </Card.Text>
                                    <Badge >Jan-Mar</Badge>
                                 </Card.Body>
                                 <div className='SeasonalFruitArrow' style={{backgroundColor : "#f4b9bf"}}>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                 </div>
                              </Card>
                           </div>
                        </div>

                        <div className="row">
                           <div className='col-12 col-lg'>
                              <Card className='CustomCard' style={{backgroundColor:"#f7efd0"}}>
                                 <Card.Img variant="top" src={Sindhura} />
                                 <Card.Body >
                                    <Card.Title >Strawberry</Card.Title>
                                    <Card.Text >
                                       Flavour details Lorem ipsum
                                       dolor sit amet. Id ducimus
                                       molestias id doloremque eaque.
                                    </Card.Text>
                                    <Badge >Jan-Mar</Badge>
                                 </Card.Body>
                                 <div className='SeasonalFruitArrow' style={{backgroundColor : "#f4e09b"}}>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                 </div>
                              </Card>
                           </div>
                           <div className='col-12 col-lg'>
                              <Card className='CustomCard' style={{backgroundColor:"#ffe8d7"}}>
                                 <Card.Img variant="top" src={Sindhura} />
                                 <Card.Body >
                                    <Card.Title >Strawberry</Card.Title>
                                    <Card.Text >
                                       Flavour details Lorem ipsum
                                       dolor sit amet. Id ducimus
                                       molestias id doloremque eaque.
                                    </Card.Text>
                                    <Badge >Jan-Mar</Badge>
                                 </Card.Body>
                                 <div className='SeasonalFruitArrow'  style={{backgroundColor : "#f7c5b5"}}>
                                    <FontAwesomeIcon icon={faArrowRight} />
                                 </div>
                              </Card>
                           </div>
                        </div>
                     </div>
                  </div>
               </Container>
            </div>
         </div> */}




      </div>


   );


}

export default FruitListing